import * as Api from '@Api/index';
import { BackendError } from '@Common/errors';

import type { Query } from '@Types/Base';
import type { ApiResponse } from '@Types/Api';

export type Region = {
  id: string;
  name: string;
  slug: string;
  isFranchisee: boolean;
};

export async function getRegionsList(request: Query): Promise<Region[]> {
  const url = `/backend/promoapi/regions`;
  const res = await Api.queryProxi<ApiResponse<Region[]>>(url, {}, request);

  if (!res.ok) throw new BackendError(url, res);

  return res.data;
}
